import React, { createContext, useCallback, useContext } from "react";

interface ElementsMinWidthContextValues {
  minWidth: number;
  proposeMinWidth: (width: number) => void;
}

const ElementsMinWidthContext = createContext<ElementsMinWidthContextValues>({
  minWidth: 0,
  proposeMinWidth: () => {},
});

export const ElementsMinWidthProvider: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const [minWidth, setMinWidth] = React.useState(0);

  const proposeMinWidth = useCallback((width: number) => {
    setMinWidth((currentWidth) => Math.max(currentWidth, Math.round(width)));
  }, []);

  return (
    <ElementsMinWidthContext.Provider value={{ minWidth, proposeMinWidth }}>
      {children}
    </ElementsMinWidthContext.Provider>
  );
};

export const useElementsMinWidth = () => {
  const { minWidth, proposeMinWidth } = useContext(ElementsMinWidthContext);

  const ref = useCallback(
    (node: HTMLDivElement | null) => {
      if (node) {
        proposeMinWidth(node.getBoundingClientRect().width);
      }
    },
    [proposeMinWidth],
  );

  return { ref, minWidth };
};
